import {Component, Input} from '@angular/core';
import {EventItem} from "@model";

@Component({
  selector: 'app-event-lengths-display',
  templateUrl: './event-lengths-display.component.html',
  styleUrl: './event-lengths-display.component.scss',
  standalone: false
})
export class EventLengthsDisplayComponent {
  @Input({required: true}) event: EventItem | undefined;
  @Input() showIcon: boolean = true;
  @Input() cssClass: string = "color-slate-600";
}
